import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { StyleClassModule } from 'primeng/styleclass';
import { MenuItem } from 'primeng/api';
import { LayoutService } from '../../services/layout.service';
import { PopoverModule } from 'primeng/popover';
import { AuthApiService } from '../../../core/services/auth-api.service';
import { Divider } from 'primeng/divider';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [RouterModule, CommonModule, StyleClassModule, PopoverModule, Divider, AvatarModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  items!: MenuItem[];

  @Input()
  electionName!: string | null;
  @Input()
  daysRemaining!: number | null;
  roles!: string[] | undefined
  username = '' 

  constructor(public layoutService: LayoutService, private logoutService: AuthApiService,
    private router: Router
  ) {
      this.roles = localStorage.getItem('roles')?.split(',');
      this.username = localStorage.getItem('username') || ''
  }

  toggleDarkMode() {
      this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
  }

  logout() {
    this.logoutService.logout();
    this.router.navigateByUrl("auth/login");
  }

  goSettings(tab: string) {
    this.router.navigateByUrl("settings#" + tab);
  }

  isAdmin(){
    return this.roles != undefined ? this.roles.includes("ROLE_SYS_ADMIN") : false
  }
}
